<template>
  <component
    :is="tag"
    class="community-contact-item"
  >
    <div class="community-contact-clickable" @click="goToProfile">
      <b-avatar
        size="42"
        :src="user.profile.image"
        :badge="true"
        class="badge-minimal"
        :badge-variant="resolveAvatarBadgeVariant(user.profile.onlineStatus)"
        variant="transparent"
      />
      <div class="chat-info flex-grow-1">
        <h5 class="mb-0">
          {{ user.userName || $t('Anonymous') }}
          <b-badge
            v-if="user.status"
            pill
            class="community-status-badge ml-1"
          >
            {{ user.status }}
          </b-badge>
        </h5>
        <p class="card-text text-truncate community-relation">
          <img :src="communityHeartIcon" width="12" height="12" class="relation-icon" />
          {{ user.tag || $t('Not Connection') }}
        </p>
      </div>
    </div>
    <div class="chat-meta text-nowrap">
      <div class="community-message-btn" @click.stop="openChat">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </component>
</template>

<script>
import { BAvatar, BBadge } from 'bootstrap-vue'
import { useRouter } from '@core/utils/utils'
import useChat from './useChat'

export default {
  components: {
    BAvatar,
    BBadge,
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      communityHeartIcon: require('@/assets/images/icons/comunnity-heart.png'),
    }
  },
  setup(props, { emit }) {
    const { resolveAvatarBadgeVariant } = useChat()
    const { router } = useRouter()

    const goToProfile = () => {
      router.push({ name: 'users.show', params: { id: props.user.id } })
    }

    const openChat = () => {
      emit('open-chat', props.user.id)
    }

    return {
      resolveAvatarBadgeVariant,
      goToProfile,
      openChat,
    }
  },
}
</script>

<style lang="scss" scoped>
.community-contact-item {
  display: flex;
  align-items: center;
  padding: 0.786rem 1.286rem;
}

.community-contact-clickable {
  display: flex;
  align-items: center;
  flex: 1;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
}

.community-status-badge {
  font-size: 10px;
  padding: 2px 6px;
  background: linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%);
  border: none;
  vertical-align: middle;
}

.community-relation {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #9333ea !important;

  .relation-icon {
    flex-shrink: 0;
  }
}

.community-message-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
}
</style>
